export type PurchaseFilters = {
  type: string
  orderStatus: string | null
  deliveryDate: [string | null, string | null]
  purchaseCode: string
  senderBusinessRefCodeProfileName: string
}

export const INITIAL_PURCHASE_FILTERS: PurchaseFilters = {
  type: "PURCHASE",
  orderStatus: null,
  deliveryDate: [null, null],
  purchaseCode: "",
  senderBusinessRefCodeProfileName: "",
}

/**
 * One search box serves «PO №, худалдан авагч»: text with a digit is a PO number (PO-100265),
 * anything else is matched against the buyer business (the backend has no combined filter).
 */
export function searchToFilters(text: string): Pick<PurchaseFilters, "purchaseCode" | "senderBusinessRefCodeProfileName"> {
  const q = text.trim()
  if (!q) return { purchaseCode: "", senderBusinessRefCodeProfileName: "" }
  return /\d/.test(q)
    ? { purchaseCode: q, senderBusinessRefCodeProfileName: "" }
    : { purchaseCode: "", senderBusinessRefCodeProfileName: q }
}
